export default __webpack_public_path__ + "f35cfd4268b5829d665b699072087dbe.png";